import { GMXExpandTileBase } from '../expand-tile-base/expand-tile-base'
import { GMXCarousel } from '../../../core/carousel/carousel'

/**
 * Tile - Carousel Tile
 */
export class GMXCarouselTile extends GMXExpandTileBase {
	collapsedContainerCarouselEl: GMXCarousel
	expandedContentContainerEl: HTMLElement
	expandedContainerCarouselEl: GMXCarousel

	private boundCollapsedContainerCarouselPrevControlCallback = this._handleCollapsedContainerCarouselPrevControlClicked.bind(this)
	private boundCollapsedContainerCarouselNextControlCallback = this._handleCollapsedContainerCarouselNextControlClicked.bind(this)

	private boundExpandedContainerCarouselPrevControlCallback = this._handleExpandedContainerCarouselPrevControlClicked.bind(this)
	private boundExpandedContainerCarouselNextControlCallback = this._handleExpandedContainerCarouselNextControlClicked.bind(this)

	connectedCallback(): void {
		super.connectedCallback()

		this.collapsedContainerCarouselEl = this.querySelector('.collapsed-content-container gmx-carousel')
		this.collapsedContainerCarouselEl.addEventListener('gmxCarouselPreviousControlClicked', this.boundCollapsedContainerCarouselPrevControlCallback)
		this.collapsedContainerCarouselEl.addEventListener('gmxCarouselNextControlClicked', this.boundCollapsedContainerCarouselNextControlCallback)

		this.expandedContentContainerEl = this.querySelector('.expanded-content-container')
		this.expandedContainerCarouselEl = this.querySelector('.expanded-content-container gmx-carousel')

		if (this.expandedContainerCarouselEl) {
			this.expandedContainerCarouselEl.addEventListener('gmxCarouselPreviousControlClicked', this.boundExpandedContainerCarouselPrevControlCallback)
			this.expandedContainerCarouselEl.addEventListener('gmxCarouselNextControlClicked', this.boundExpandedContainerCarouselNextControlCallback)
		}
	}

	disconnectedCallback(): void {
		super.disconnectedCallback()

		this.collapsedContainerCarouselEl.removeEventListener('gmxCarouselPreviousControlClicked', this.boundCollapsedContainerCarouselPrevControlCallback)
		this.collapsedContainerCarouselEl.removeEventListener('gmxCarouselNextControlClicked', this.boundCollapsedContainerCarouselNextControlCallback)

		this.expandedContainerCarouselEl.removeEventListener('gmxCarouselPreviousControlClicked', this.boundExpandedContainerCarouselPrevControlCallback)
		this.expandedContainerCarouselEl.removeEventListener('gmxCarouselNextControlClicked', this.boundExpandedContainerCarouselNextControlCallback)
	}

	onOverlayLoaded(): void {
		this.expandedContainerCarouselEl = this.querySelector('.expanded-content-container gmx-carousel')
		this.expandedContainerCarouselEl.addEventListener('gmxCarouselPreviousControlClicked', this.boundExpandedContainerCarouselPrevControlCallback)
		this.expandedContainerCarouselEl.addEventListener('gmxCarouselNextControlClicked', this.boundExpandedContainerCarouselNextControlCallback)
	}

	/**
	 * Callback to handle when the carousel in the collapsed tile view's back/previous slide button is clicked.  To
	 * keep the collapsed and expanded carousels in sync, would need to also trigger the activate previous slide in
	 * the expanded carousel as well.
	 *
	 * @private
	 */
	private _handleCollapsedContainerCarouselPrevControlClicked(): void {
		this.expandedContainerCarouselEl.activatePreviousSlide()
	}

	/**
	 * Callback to handle when the carousel in the collapsed tile view's next slide button is clicked.  To
	 * keep the collapsed and expanded carousels in sync, would need to also trigger the activate next slide in
	 * the expanded carousel as well.
	 *
	 * @private
	 */
	private _handleCollapsedContainerCarouselNextControlClicked(): void {
		this.expandedContainerCarouselEl.activateNextSlide()
	}

	/**
	 * Callback to handle when the carousel in the expanded tile view's back/previous slide button is clicked.  To
	 * keep the collapsed and expanded carousels in sync, would need to also trigger the activate previous slide in
	 * the collapsed carousel as well.
	 *
	 * @private
	 */
	private _handleExpandedContainerCarouselPrevControlClicked(): void {
		this.collapsedContainerCarouselEl.activatePreviousSlide()
	}

	/**
	 * Callback to handle when the carousel in the expanded tile view's next slide button is clicked.  To
	 * keep the collapsed and expanded carousels in sync, would need to also trigger the activate next slide in
	 * the collapsed carousel as well.
	 *
	 * @private
	 */
	private _handleExpandedContainerCarouselNextControlClicked(): void {
		this.collapsedContainerCarouselEl.activateNextSlide()
	}
}

if (!customElements.get('gmx-carousel-tile')) {
	customElements.define('gmx-carousel-tile', GMXCarouselTile)
}
